import type { AppDispatch } from 'mastodon/store';

import api from '../api';

import { showAlertForError } from './alerts';

export const changeAdvancedLayout =
  (advancedLayout: boolean, redirectTo?: string) =>
  (dispatch: AppDispatch) => {
    api()
      .put('/api/web/advanced_layout', { advanced_layout: advancedLayout })
      .then(() => {
        if (redirectTo) {
          window.location.assign(redirectTo);
        } else {
          window.location.reload();
        }

        return undefined;
      })
      .catch((error: unknown) => {
        dispatch(showAlertForError(error));
      });
  };
